import React, { useState } from 'react';
import { Container, Row, Col, Button, Carousel, Tab, Nav } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import servicesData from './ServiceData'; // Make sure this path is correct
import styles from './ServiceDetails.module.css'; // Make sure this path is correct
import '../App.css'
import GigReviews from "../components/GigReviews"

const ServiceDetails = () => {
    const { serviceId } = useParams();
    const service = servicesData.find(s => s.id === parseInt(serviceId, 10));

    const [activeKey, setActiveKey] = useState(service?.packages[0]?.name.toLowerCase() || 'basic');

    if (!service) {
        return <div className={styles.notFound}>Service not found</div>;
    }

    return (
        <Container className={styles.serviceDetailsContainer}>
            <Row>
                <Col md={8} className={styles.carouselContainer}>
                    <h2 className={styles.serviceTitle}>{service.title}</h2>
                    <Carousel interval={null}>
                        {service.images.map((img, index) => (
                            <Carousel.Item key={index}>
                                <img className="d-block w-100" src={img} alt={`Service Image ${index}`} />
                            </Carousel.Item>
                        ))}
                    </Carousel>
                    <GigReviews serviceId={parseInt(serviceId, 10)} />
                    <p className={styles.serviceDescription1}>{service.description1}</p>
                            <p className={styles.serviceDescription2}>{service.description2}</p>
                        <div className={styles.features}>
                            <h5 className={styles.featuresTitle}><b>Why To Choose Us?</b></h5>
                            <ul className={styles.featuresList}>
                                {service.features.map((feature, index) => (
                                    <li key={index} className={styles.feature}>{feature}</li>
                                ))}
                            </ul>
                        </div>
                         <h5 className={styles.pkjToChooseTitle}><b>Which Package To Choose?</b></h5>
                         <p className={styles.pkjToChoose1}>{service.pkjToChoose1}</p>
                         <p className={styles.pkjToChoose2}>{service.pkjToChoose2}</p>
                    <div className={styles.howItWorks}>
                        <h5 className={styles.howItWorksTitle}><b>How It Works?</b></h5>
                        <ol className={styles.howItWorksList}>
                            {service.howItWorks.map((howItWorks, index) => (
                                <li key={index} className={styles.howItWorks}>{howItWorks}</li>
                            ))}
                        </ol>
                    </div>
                    <p className={styles.finalPara}>{service.finalpara}</p>
                    <p className={styles.thankyou}>{service.thankyou}</p>

                    <div className={styles.tags}>
                            <h5 className={styles.tagsTitle}><b>Tags:</b></h5>
                            <p className={styles.tagsContent}><b>{service.tags.join(' | ')}</b></p>
                        </div>
                </Col>
                <Col md={4} className={styles.packagesContainer}>
                    <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
                        <Nav variant="pills" className={styles.navTabs}>
                            {service.packages.map((pkg) => (
                                <Nav.Item key={pkg.name}>
                                    <Nav.Link
                                        eventKey={pkg.name.toLowerCase()}
                                        className={styles.navLink}>
                                        {pkg.name}
                                    </Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>
                        <Tab.Content>
                            {service.packages.map((pkg) => (
                                <Tab.Pane
                                    key={pkg.name}
                                    eventKey={pkg.name.toLowerCase()}
                                    className={styles.tabPane}>
                                    <div className={styles.packageHeader}>
                                        <h5 className={styles.packageName}>{pkg.name.toUpperCase()}</h5>
                                        <p className={styles.packagePrice}>{pkg.price}</p>
                                    </div>
                                    <div className={styles.packageDescription}>{pkg.description}</div>
                                    <ul className={styles.packageFeatures}>
                                        {pkg.features.map((feature, idx) => (
                                            <li key={idx}>{feature}</li>
                                        ))}
                                    </ul>
                                    <div className={styles.actionButtons}>
                                        <Button className={styles.continueButton}>Continue</Button>
                                        <Button className={styles.contactButton}>Contact us</Button>
                                    </div>
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </Tab.Container>
                    <Button className={styles.customQuoteButton}>Get Free Custom Quote</Button>
                </Col>
            </Row>
        </Container>
    );
};

export default ServiceDetails;
